import { Controller } from '@hotwired/stimulus';

// Stimulus controller that keeps a scrollable container pinned to the bottom.
// - scrolls on connect
// - watches for DOM mutations and scrolls when content is added
export default class extends Controller {
  connect() {
    this.scrollToBottom();
    this.observeMutations();
  }

  disconnect() {
    this.observer?.disconnect();
  }

  observeMutations() {
    this.observer = new MutationObserver((mutations) => {
      const hasNewNodes = mutations.some((m) => m.addedNodes.length > 0);
      if (hasNewNodes) {
        this.scrollToBottom();
      }
    });

    this.observer.observe(this.element, {
      childList: true, // watch for added/removed children
      subtree: true, // also catch nested changes (e.g. turbo stream appends)
    });
  }

  scrollToBottom() {
    requestAnimationFrame(() => {
      this.element.scrollTo({
        top: this.element.scrollHeight,
        behavior: 'smooth',
      });
    });
  }
}
